module.exports = __webpack_public_path__ + "img/social-inn.1dd69af5.jpg";